import React from 'react';

const Copyright = () => {
    return (
        <div className="uk-container uk-text-center uk-padding-small">
            <h6>Made with passion by yours truly, Adrian Davila</h6>
        </div>
    )
}

export default Copyright;


// WEBPACK FOOTER //
// ./src/components/Footer/Copyright.js